<template>
  <div style="background-color: #D9D9D926; padding: 10px; margin-top: 10px;">
    <form>
      <div class="form-group mt-2">
        <button
          type="button"
          id="templateChangeButton"
          @click="toggleMessageTemplate"
          :disabled="isJdSelected"
        >
          ▼ テンプレート選択
        </button>
      </div>
      <MessageTemplateModal
        mode="accordion"
        @rowSelected="onTemplateSelected"
        v-show="showMessageTemplate"
      />
      <div class="form-group mt-2">
        <label>スカウト形式（必須）</label>
        <div style="flex:3; font-weight: normal">
          <label class="mr-3"
            ><input
              type="radio"
              name="contact_type"
              value="応募案内"
              v-model="contact_type"
            />
            応募案内</label
          >
          <label class="mr-3"
            ><input
              type="radio"
              name="contact_type"
              value="カジュアル面談"
              v-model="contact_type"
            />
            カジュアル面談</label
          >
          <label class="mr-3"
            ><input
              type="radio"
              name="contact_type"
              value="面接案内"
              v-model="contact_type"
            />
            面接案内</label
          >
          <div class="d-flex flex-column">
            <label class="mr-3">
              <input
                type="radio"
                name="contact_type"
                value="その他通知"
                v-model="contact_type"
              />
              通知のみ
              <small class="text-muted d-block mt-1"
                >※求人添付および登録者からの回答受付はできません。</small
              >
            </label>
          </div>
        </div>
      </div>

      <div class="form-group mt-2 mt-2">
        <label for="jobTitle">添付求人</label>
        <div class="input-group">
          <input
            type="text"
            id="jobTitle"
            name="jd_title"
            class="form-control"
            data-vv-as="添付求人"
            placeholder="スカウトする求人をシステムから選択する際はパラメータを入力してください"
            v-model="jd_title"
          />
          <FieldError :message="$validator.errors.first('jd_title')" />
        </div>
      </div>

      <div class="form-group mt-2">
        <label for="senderName">差出人名</label>
        <div class="input-group">
          <input
            type="text"
            id="senderName"
            name="user_name"
            class="form-control"
            :data-vv-as="'差出人名'"
            v-validate="'required'"
            v-model="user_name"
            placeholder="スカウトの差出人として表示するお名前を入力してください"
          />
          <FieldError :message="$validator.errors.first('user_name')" />
        </div>
      </div>

      <div class="form-group mt-2 mb-2">
        <label for="emailSubject" class="emailSubject">件名（必須）</label>
        <div class="input-group">
          <input
            type="text"
            name="emailSubject"
            id="emailSubject"
            class="form-control"
            data-vv-as="件名"
            v-validate="'required'"
            v-model="emailSubject"
          />
          <FieldError :message="$validator.errors.first('emailSubject')" />
        </div>
      </div>

      <div class="form-group" style="align-items: start;">
        <label for="emailBody">本文（必須）</label>
        <div class="input-group textarea">
          <TiptapEditor
            placeholder="Enter Message Body"
            v-model="emailBody"
          />
          <FieldError :message="$validator.errors.first('emailBody')" />
        </div>
      </div>
      <div class="form-group mt-2">
        <label style="font-size: 14px;flex: initial !important;"
          >不足書類の提出依頼</label
        >
        <div style="flex:2">
          <label class="mr-4 ml-2"
            ><input
              type="checkbox"
              name="fileRequest"
              value="職務経歴書"
              v-model="fileRequest"
              :disabled="isOtherNotifications"
            />
            職務経歴書</label
          >
          <label
            ><input
              type="checkbox"
              name="fileRequest"
              value="履歴書"
              v-model="fileRequest"
              :disabled="isOtherNotifications"
            />
            キャリア登録情報以外の履歴書</label
          >
        </div>
        <br />
      </div>
      <p class="red" style="margin-left: 150px;">
        ※不足書類の提出依頼をすると、応募率が下がる場合があります。
      </p>
    </form>

    <!-- Message Button -->
    <div class="message-button-container p-2">
      <button class="btn message-button" @click="previewForm">
        送信確認画面へ
      </button>
    </div>

    <ConfirmationModal
      ref="confirmationModal"
      :message="detailTexts"
      confirmBtnText="送信確認画面へ"
      @cancel="closeConfirmModal"
      @confirm="showPreviewModal(true)"
    />
    <b-modal
      ref="my-modal"
      hide-header
      id="preview-modal"
      size="lg"
      class="custom-modal"
    >
      <div class="main-container" style="padding:20px">
        <div class="d-flex flex-column align-items-start">
          <div class="title text-center">
            <div class="title-1">
              <span style="font-size: 24px;font-weight: bold;">{{
                company
              }}</span
              ><br />
              <span style="font-size: 14px;">{{ previewUserName }}</span>
            </div>
            <div class="preview-body mt-2">
              <p>{{ previewEmailSubject }}</p>
            </div>
          </div>

          <div class="d-block text-left">
            <div class="preview-body" v-html="previewEmailBody"></div>
          </div>
          <div class="jd-info" v-if="showJDCleanDisplay">
            <p class="jd-title" @click="openJdModal">
              {{ applicantJd.jd_info.job_title }}
            </p>
          </div>
          <div
            class="button-container d-flex justify-content-center m-auto"
            v-if="!isOtherNotifications"
          >
            <button
              class="btn btn-secondary cancel-text-button mr-4"
              style="white-space: initial"
              :disabled="true"
            >
              今回は控える
            </button>
            <button
              class="btn btn-info submit-text-button"
              v-html="submitButtonText"
              :disabled="true"
            ></button>
          </div>
        </div>
      </div>
      <template #modal-footer>
        <button class="btn btn-white-rounded mr-3" @click="hideModal">
          メッセージ作成に戻る
        </button>
        <button
          class="btn btn-red-rounded"
          @click.prevent="checkJdInfoMissing()"
          :disabled="isSubmitting"
        >
          送信
        </button>
      </template>
      <IndividualJDModal
        v-if="showJdModal"
        :jd="applicantJd.jd_info"
        :submitButtonText="submitButtonText"
        :isOpen="showJdModal"
        :isOtherNotifications="isOtherNotifications"
        :isQuestionRequest="isQuestionRequest"
        :company="company"
        @closeJdModal="closeJdModal"
      />
    </b-modal>
    <div v-if="showWarningModal" class="warning-modal-overlay">
      <div class="warning-modal">
        <div class="warning-modal-content">
          <div class="warning-icon">
            <img src="@/assets/images/Warning.png" alt="warning" />
          </div>
          <div class="warning-message">
            設定したJDの掲載終了、<br />
            もしくはデータ不具合が発生している可能性があります。<br />
            JDの設定状況を確認してください。
          </div>
          <div class="warning-button">
            <button @click="closeWarningModal" class="btn btn-secondary">
              個別連絡作成に戻る
            </button>
          </div>
        </div>
      </div>
    </div>

    <b-modal v-model="showUnresolvedModal" centered hide-footer hide-header>
      <div class="warning-modal-content">
        <div class="warning-icon text-center">
          <img src="@/assets/images/Warning.png" alt="warning" />
        </div>
        <h5 class="text-center font-weight-bold">このまま送信しますか？</h5>
        <div class="warning-message mt-3 text-center">
          このまま送信しますか？<br />文中にundefinedが存在している可能性があります。
        </div>
        <div class="warning-button d-flex justify-content-center mt-3">
          <b-button
            variant="secondary"
            class="mr-3"
            @click="closeUnresolvedModal"
          >
            編集に戻る
          </b-button>
          <b-button
            variant="warning"
            @click.prevent="onsubmit()"
            :disabled="isSubmitting"
          >
            送信する
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import DOMPurify from 'dompurify';
import TiptapEditor from '@/components/utils/TiptapEditor.vue';
import MessageTemplateModal from './MessageTemplate/MessageTemplateModal.vue';
import ScoutJobSection from './ScoutJobSection.vue';
import ScoutTypeSection from './ScoutTypeSection.vue';
import FieldError from '@/components/utils/FieldError.vue';
import IndividualJDModal from './IndividualJDModal.vue';
import ConfirmationModal from '../../utils/ConfirmationModal.vue';
import { mapActions, mapState } from 'vuex';
export default {
  name: 'MessageCompose',
  components: {
    MessageTemplateModal,
    FieldError,
    TiptapEditor,
    IndividualJDModal,
    ConfirmationModal,
    ScoutJobSection,
    ScoutTypeSection,
  },
  props: [
    'company',
    'applicant',
    'sentDate',
    'formData',
    'draftMessage',
    'isSubmitting',
    'isFirstMessage',
    'applicantJD',
  ],
  data() {
    return {
      user_name: '',
      contact_type: '応募案内',
      questionRequest: 'false',
      jd_url: '',
      jd_title: '',
      fileRequest: [],
      emailSubject: '',
      emailBody: '',
      jdDisplay: false,
      tempFormData: {},
      fetchedApplicant: undefined,
      previewUserName: null,
      previewEmailBody: '',
      previewEmailSubject: '',
      showMessageTemplate: false,
      selectedTemplate: undefined,
      errors: [],
      activeButton: 'body',
      isMessageValid: false,
      showWarningModal: false,
      showUnresolvedModal: false,
      showJdModal: false,
      replyMessage: false,
      applicantJd: this.applicantJD,
    };
  },
  computed: {
    ...mapState({
      currentApplicantJd: ({ applicant }) => applicant.jdForContact,
    }),
    detailTexts() {
      return `スカウトする求人が選択されていません<br/><span style="display:block;margin-top: 20px;">このまま送信確認画面へ進みますか?</span>`;
    },
    getPlaceholderVar() {
      return [
        'last_name',
        'user_name',
        'jd_title',
        'jd_url',
        'company',
        'selected_jd_title',
        'selected_jd_detail',
        'selected_jd_qualification',
        'selected_jd_location',
        'selected_jd_salary',
      ];
    },
    showJDCleanDisplay() {
      if (this.contact_type === 'その他通知') {
        // For その他通知, only show if %selected_jd_title% parameter is used
        return false
      }
      return this.applicantJd && this.applicantJd.jd_info 
    },
    applicantJdInfo() {
      if (
        this.applicantJd &&
        this.applicantJd.jd_info &&
        this.activeButton === 'jd'
      ) {
        const { jd_info } = this.applicantJd;
        this.emailBody =
          this.createHeaderElement('h5', jd_info.job_title) +
          '\n\n' +
          jd_info.job_description;
        return (
          this.createHeaderElement('h5', jd_info.job_title) +
          '\n\n' +
          jd_info.job_description
        );
      } else {
        return '';
      }
    },
    submitButtonText() {
      if (this.contact_type === '応募案内') {
        return '応募する';
      } else if (this.contact_type === 'カジュアル面談') {
        return 'カジュアル面談に\r\n参加する';
      } else {
        return '<span style="font-size:12px">選考に応募して</span><br/><span>面接に参加する</span>';
      }
    },
    isQuestionRequest() {
      return this.questionRequest === true || this.questionRequest === 'true';
    },
    isOtherNotifications() {
      return this.contact_type === 'その他通知';
    },
    isJdSelected() {
      return this.activeButton === 'jd';
    },
  },
  methods: {
    ...mapActions({ getOrLoadMessageTemplates: 'getOrLoadMessageTemplates' }),
    toggleMessageTemplate() {
      this.showMessageTemplate = !this.showMessageTemplate;
    },
    openJdModal() {
      this.showJdModal = true;
    },
    closeJdModal() {
      this.showJdModal = false;
    },
    buttonClass(button) {
      if (this.activeButton === button) {
        return 'btn-active';
      } else {
        return 'btn-inactive';
      }
    },
    setActiveButton(button) {
      this.activeButton = button;
      const formDataKeys = ['jd_url', 'jd_title', 'emailBody'];
      if (button === 'jd' && this.applicantJd && this.applicantJd.jd_info) {
        formDataKeys.forEach((key) => {
          this.tempFormData[key] = this[key];
        });
        this.jd_title = this.applicantJd.jd_info.job_title;
        this.jd_url = this.applicantJd.jd_info.jd_url;
        this.emailBody = '';
      } else {
        formDataKeys.forEach((key) => {
          this[key] = this.tempFormData[key];
        });
      }
    },
    createHeaderElement(tag, content) {
      return `<${tag}>${content}</${tag}>`;
    },
    validateMessageBody() {
      // this.isMessageValid = this.emailBody.trim() !== '';
      if (!this.emailBody) this.emailBody = '';
      const bodyContentMatch = this.emailBody.match(
        /<body[^>]*>[\s\S]*<\/body>/i
      );
      const bodyContent = bodyContentMatch ? bodyContentMatch[0] : '';
      // Example validation: Check if the extracted content is not empty
      const userEnteredContent = bodyContent
        .replace(/<\/?[^>]+(>|$)/g, '')
        .replace(/&nbsp;/g, '')
        .trim();
      const content2 = this.emailBody
        .replace(/<\/?[^>]+(>|$)/g, '')
        .replace(/&nbsp;/g, '')
        .trim();

      this.isMessageValid = content2 || userEnteredContent !== '';
      if (!this.isMessageValid) {
        this.$validator.errors.add({
          field: 'emailBody',
          msg: '本文は必須項目です',
        });
      } else {
        this.$validator.errors.remove('emailBody');
      }
    },
    closeConfirmModal() {
      this.$refs.confirmationModal.hide();
    },
    cancel() {
      this.$emit('cancel');
    },
    async processMessage() {
      if (!this.applicantJd || !this.applicantJd.jd_info) {
        let isOk = await this.$validator.validate();
        this.validateMessageBody();
        if (!isOk || Object.keys(this.errors).length || !this.isMessageValid) {
          let element = document.getElementsByClassName('is-invalid ')[0];
          if (element) {
            element.scrollIntoView();
          } else {
            element = document.getElementsByClassName('invalid-feedback')[0];
            element.scrollIntoView();
          }
          if (!this.isMessageValid) {
            // console.log('here');
            this.$validator.errors.add({
              field: 'emailBody',
              msg: '本文は必須項目です',
            });
          }
        }
        this.processPlaceholder();
        this.previewForm();
        // this.$refs.confirmationModal.show();
      } else {
        this.previewForm();
      }
    },
    showPreviewModal() {
      this.previewForm();
    },
    processPlaceholder() {
      // console.log(this.user_name);
      this.previewUserName =
        this.user_name && /%[^%]+%/.test(this.user_name)
          ? this.replacePlaceholder(this.user_name)
          : this.user_name;
      this.previewEmailBody = DOMPurify.sanitize(
        this.replacePlaceholder(this.emailBody),
        { ADD_ATTR: ['target'] }
      );
      this.previewEmailBody = this.processEmailBody(this.previewEmailBody);
      this.previewEmailSubject = this.replacePlaceholder(this.emailSubject);
    },
    async previewForm() {
      let isOk = await this.$validator.validate();
      this.validateMessageBody();
      if (!isOk || Object.keys(this.errors).length || !this.isMessageValid) {
        let element = document.getElementsByClassName('is-invalidM ')[0];
        if (element) {
          element.scrollIntoView();
        } else {
          element = document.getElementsByClassName('invalid-feedback')[0];
          element.scrollIntoView();
        }
        if (!this.isMessageValid) {
          // console.log('here');
          this.$validator.errors.add({
            field: 'emailBody',
            msg: '本文は必須項目です',
          });
        }
      } else {
        this.processPlaceholder();
        this.$refs['my-modal'].show();
      }
    },
    processEmailBody(htmlString) {
      // Updated regex to capture the entire href attribute including quotes
      const linkRegex = /<a[^>]+href=["']([^"']*)["']/g;

      const processedHTML = htmlString.replace(linkRegex, (match, link) => {
        // Skip empty, undefined, or # links
        if (
          !link ||
          link === 'undefined' ||
          link === '#' ||
          link.trim() === ''
        ) {
          return match
            .replace(/<a/i, '<span')
            .replace(/href=["'][^"']*["']/i, '');
        }

        // Add https:// if needed
        if (!/^https?:\/\//i.test(link)) {
          return match.replace(link, `https://${link}`);
        }

        return match;
      });
      // Find and linkify valid URLs that aren't already in <a> tags
      const urlRegex = /(?<!<a[^>]*)(https?:\/\/[^\s<]+|www\.[^\s<]+\.[^\s<]+)(?![^<]*>)/g;
      return processedHTML.replace(
        urlRegex,
        (url) => `<a href="${url}">${url}</a>`
      );
    },
    hideModal() {
      const modal = this.$refs['my-modal'];
      if (modal && typeof modal.hide === 'function') modal.hide();
    },
    onHideModal() {
      this.showMessageTemplate = false;
    },
    async onTemplateSelected(id) {
      this.selectedTemplate = undefined;
      let allTemplates = await this.getOrLoadMessageTemplates();
      this.selectedTemplate = allTemplates.find(
        (template) => template._id === id
      );
      this.showMessageTemplate = false;
    },
    getFormData() {
      return {
        companyName: this.company,
        sender: this.previewUserName,
        contact_type: this.contact_type,
        question_request: this.isQuestionRequest,
        job_title:
          this.jd_title === '%selected_jd_title%'
            ? this.applicantJd && this.applicantJd.jd_info
              ? this.applicantJd.jd_info.job_title
              : this.jd_title
            : this.jd_title,
        job_url:
          this.jd_url && this.jd_url.trim() !== ''
            ? this.checkAndUpdateUrl(this.jd_url)
            : this.jd_url,
        subject: this.previewEmailSubject,
        body: this.previewEmailBody,
        file_upload_request: this.fileRequest,
        jd_display: this.jdDisplay,
        isJdTitleUsed: this.jd_title.includes('%selected_jd_title%'),
      };
    },

    closeWarningModal() {
      this.showWarningModal = false;
      this.hideModal();
    },
    closeUnresolvedModal() {
      this.showUnresolvedModal = false;
      this.hideModal();
    },
    checkJdInfoMissing() {
      // 1. First check: JD placeholders with missing JD info
      const placeholderPatterns = [
        '%selected_jd_title%',
        '%selected_jd_detail%',
        '%selected_jd_qualification%',
        '%selected_jd_location%',
        '%selected_jd_salary%',
      ];

      const hasJdPlaceholder = placeholderPatterns.some(
        (pattern) =>
          this.emailBody.includes(pattern) ||
          this.emailSubject.includes(pattern) ||
          (this.jd_title && this.jd_title.includes(pattern))
      );

      const isJdInfoMissing = !this.applicantJd || !this.applicantJd.jd_info;
      // Show first warning if JD placeholders exist but JD info is missing
      // if (hasJdPlaceholder && isJdInfoMissing) {
      //   this.showUnresolvedModal = true; // Modal for missing JD
      //   return true;
      // }

      this.jdDisplay = true;

      // 2. Second check: Look for any remaining % or undefined
      const hasUnresolvedPattern =
        /%/.test(this.previewEmailBody) ||
        this.previewEmailBody.includes('undefined');

      // Show second warning if there are unresolved patterns
      if (hasUnresolvedPattern) {
        this.showUnresolvedModal = true; // Different modal for unresolved patterns
        return true;
      }

      this.onsubmit();
    },

    onsubmit(skip_preview = false) {
      let draft = this.draftMessage ? this.draftMessage._id : null;
      let draftId;
      if (draft) draftId = draft;
      let formData = this.getFormData(skip_preview);

      this.$emit('onSubmit', {
        data: formData,
        reset: this.onReset,
        hide: this.hideModal,
        draftId: draftId,
      });
    },
    onReset() {
      this.body = '';
      this.user_name = '';
      this.emailBody = '';
      this.emailSubject = '';
      this.fileRequest = [];
      this.jd_url = '';
      this.jd_title = '';
      this.selectedTemplate = undefined;
      this.jdDisplay = false;
      this.$validator.reset();
    },
    checkAndUpdateUrl(url) {
      if (!/^https?:\/\//i.test(url)) {
        return 'https://' + url;
      } else {
        return url;
      }
    },
    replacePlaceholder(body) {
      let tempBody = body;
      let placeholders = this.getPlaceholderVar;
      for (let placeholder of placeholders) {
        if (this.applicant.hasOwnProperty(placeholder)) {
          const value = this.applicant[placeholder];
          if (value !== undefined && value !== null && value !== '') {
            tempBody = tempBody.replace(
              new RegExp(`%jobseeker.${placeholder}%`, 'g'),
              value
            );
          }
        } else {
          let placeholderValue = this[placeholder];
          if (
            placeholder === 'jd_url' &&
            placeholderValue &&
            !/^https?:\/\//i.test(placeholderValue)
          ) {
            placeholderValue = 'https://' + placeholderValue;
          }
          if (
            !placeholderValue &&
            this.applicantJd &&
            this.applicantJd.jd_info
          ) {
            const jdPlaceholderMap = {
              selected_jd_title: this.applicantJd.jd_info.job_title,
              selected_jd_detail: this.applicantJd.jd_info.job_description,
              selected_jd_qualification: this.applicantJd.jd_info.qualification,
              selected_jd_location: this.applicantJd.jd_info.location,
              selected_jd_salary: this.applicantJd.jd_info.salary,
            };
            placeholderValue = jdPlaceholderMap[placeholder] || null;
          }
          if (placeholderValue !== undefined && placeholderValue !== null && placeholderValue !== '') {
            tempBody = tempBody.replace(
              new RegExp(`%${placeholder}%`, 'g'),
              placeholderValue
            );
          }
        }
      }
      return tempBody;
    },
    prepopulateForm() {
      // console.log(this.draftMessage)
      this.user_name = this.draftMessage ? this.draftMessage.sender : '';
      this.contact_type =
        this.draftMessage && this.draftMessage.contact_type
          ? this.draftMessage.contact_type
          : '応募案内';
      // If contact_type is 'その他通知', questionRequest should be false
      if (this.contact_type === 'その他通知') {
        this.questionRequest = 'false';
      } else {
        this.questionRequest =
          this.draftMessage && this.draftMessage.question_request
            ? this.draftMessage.question_request
            : 'false';
      }
      this.jd_title = this.draftMessage ? this.draftMessage.job_title : '';
      this.jd_url = this.draftMessage ? this.draftMessage.job_url : '';
      this.emailSubject = this.draftMessage ? this.draftMessage.subject : '';
      this.emailBody = this.draftMessage ? this.draftMessage.body : '';
      this.fileRequest =
        this.draftMessage && this.draftMessage.file_upload_request
          ? this.draftMessage.file_upload_request
          : [];
      this.jdDisplay =
        this.draftMessage && this.draftMessage.jd_display
          ? this.draftMessage.jd_display
          : false;
      // console.log(this.fileRequest);
    },
  },
  watch: {
    emailBody: {
      handler() {
        this.validateMessageBody();
      },
      deep: true,
    },

    currentApplicantJd(newVal) {
      this.applicantJd = newVal;
    },
    contact_type(newVal) {
      if (newVal === 'その他通知') {
        this.questionRequest = 'false';
        this.fileRequest = [];
        this.jdDisplay = false;
      }
    },
    selectedTemplate: {
      handler(newTemplate) {
        this.emailSubject = newTemplate ? newTemplate.subject : '';
        this.emailBody = newTemplate ? newTemplate.body : '';
        this.jd_title = newTemplate ? newTemplate.job_title : '';
        this.jd_url = newTemplate ? newTemplate.job_url : '';
        this.contact_type =
          newTemplate && newTemplate.contact_type
            ? newTemplate.contact_type
            : '応募案内';
        // If contact_type is 'その他通知', questionRequest should be false
        if (this.contact_type === 'その他通知') {
          this.questionRequest = 'false';
        } else {
          this.questionRequest = newTemplate
            ? newTemplate.question_request
            : 'false';
        }
        this.user_name = newTemplate ? newTemplate.sender : '';
      },
      immediate: true,
    },
  },
  created() {
    this.prepopulateForm();
  },
};
</script>

<style scoped>
.jd-info {
  padding: 10px;
  margin: auto;
  width: 100%;
  text-align: center;
}

>>> .modal-footer {
  justify-content: center !important;
}

.jd-title {
  border: 1px solid #b3b3b3;
  padding: 20px 10px;
  border-radius: 3px;
  color: #036ac9;
  font-weight: bold;
  cursor: pointer;
}

.warning-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  animation: fadeIn 0.2s ease;
}

.warning-modal {
  background: white;
  border-radius: 2px;
  width: 377px;
  height: 401px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  padding: 0;
}

.warning-modal-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  padding: 40px 20px;
}

.warning-icon {
  color: #ff9800;
  font-size: 48px;
  margin-bottom: 40px;
  margin-top: 10px;
}

.warning-message {
  margin-bottom: auto;
  font-size: 20px;
  line-height: 24.2px;
  color: #333;
  padding: 0 5px;
  text-align: center;
}

.warning-button button {
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  min-width: 120px;
}

.btn-warning {
  background: #eb5757;
}

.warning-button button:hover {
  opacity: 0.8;
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideIn {
  from {
    transform: translateY(-20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.form-control::placeholder {
  color: #b3b3b3 !important;
}

>>> .invalid-feedback span {
  height: 0.1px !important;
}
>>> .is-valid {
  background: none !important;
}

>>> .is-invalid {
  background: none !important;
}

>>> .invalid-feedback span {
  float: right !important;
}

.btn-msg {
  min-width: 100px;
  padding: 5px;
  height: 30px;
  border-radius: 0px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
.btn-active {
  background-color: #fff !important;
  border: 1px solid #036d6c;
  color: #036d6c;
}

.btn-inactive {
  background-color: gray;
}

.input-group {
  width: 85% !important;
  max-width: 85%;
  overflow: visible;
}

.input-group.textarea {
  display: flex;
  flex-direction: column;
  width: 85% !important;
  max-width: 85%;
  overflow: visible;
}

.page-content {
  margin-top: 5px;
}

.ibox {
  background: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
}

.ibox-body {
  padding: 15px;
}

.preview-body {
  /* white-space: pre-line; */
  word-break: break-word;
}

.text-center {
  text-align: center;
}

.line {
  border-bottom: 2px solid #000;
  width: 95%;
  margin: 0 auto;
}
.title {
  /* padding: 20px; */
  text-align: center;
  word-break: break-word;
  /* border-bottom: 0.5px solid gray; */
}

.line1 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.sent-date {
  margin: 0;
  text-align: right;
}

.line2 {
  text-align: center;
}

.title-1 {
  text-align: left;
}

.title-2 {
  text-align: left;
  font-size: 20px;
  font-weight: lighter;
}

.custom-modal {
  padding: 0px;
  border: 10px solid #617776 !important;
  box-shadow: 0 0 10px rgba(0.2);
}
.button-container button:disabled {
  opacity: 10;
}

.button-container {
  padding: 10px;
  /* background: #f2f5f7; */
}

.buttons {
  padding: 20px;
}

.form-group {
  display: flex;
  align-items: center;
  margin-bottom: 3px;
  color: #3c3c3c;
  font-size: 14px;
  font-weight: 700;
  max-width: 100%;
  overflow: hidden;
}

.form-group label {
  flex: 1;
  vertical-align: middle;
  padding: 2px;
  word-wrap: break-word;
  word-break: break-word;
  overflow-wrap: break-word;
}

.form-group input[type='radio'] {
  flex: 3 !important;
  width: 20px !important;
  height: 20px;
  vertical-align: middle;
}

.form-group input[type='checkbox'] {
  width: 20px !important;
  height: 20px;
  vertical-align: middle;
}

.form-control {
  flex: 7;
  border: 1px solid #ccc;
  padding: 5px;
  border-radius: 2px;
  font-size: 14px !important;
  word-wrap: break-word;
  word-break: break-word;
  overflow-wrap: break-word;
  max-width: 100%;
  /* font-size: 20px; */
}

#templateChangeButton {
  width: 200px;
  height: 30px;
  font-size: 14px;
  background: #ffffff !important;
  color: #000;
  padding: 5px;
  border: 1px solid #000;
  border-radius: 30px;
}
#templateChangeButton:disabled {
  opacity: 0.6;
}

.emailSubject {
  /* border: 1px solid #ccc; */
  padding: 7px;
  border-radius: 2px;
  /* margin-top: 8px; */
  /* text-align: center; */
}

.cancel-button {
  min-width: 112px;
  width: 112px;
  font-size: 14px;
  padding: 3px;
  background-color: #ffffff;
  border: 1px solid #3c3c3c;
  border-radius: 2px;
  margin-right: 20px;
  color: #3c3c3c;
}

.question-button {
  background-color: #2f80ed !important;
}

.question-button:hover {
  background-color: #2f80ed !important;
}

.submit-button {
  min-width: 115px;
  width: 115px;
  font-size: 14px;
  padding: 3px;
  border-radius: 2px;
}

.submit-text-button {
  background-color: #036d6c !important;
}

.submit-text-button,
.cancel-text-button {
  padding: 0px !important;
  width: 160px !important;
  height: 48px !important;
  white-space: pre-line;
  font-size: 14px;
  /* border: 1px solid !important; */
  border-radius: 4px !important ;
}
.submit-text-button:disabled,
.cancel-text-button:disabled {
  opacity: 1 !important;
  pointer-events: none; /* Optional: prevent click without grey-out */
}

.message-button-container {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.message-button {
  background: #036ac9;
  border-radius: 30px;
  width: 200px;
  height: 61px;
  color: #fff;
  font-size: 15px;
  font-weight: bold;
  border: none;
  cursor: pointer;
}

.message-button:hover {
  background: #025a9e;
}
</style>
